import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { layoutSaga } from './saga';
import { LayoutState } from './types';

export const initialState: LayoutState = {
  user: {},
  error: null,
  loading: false,
  isSidebarOpen: false,
  isAuthenticated: false,
  showAiAssistant: false,
  isSavedViewsExpanded: false,
  isMustWinsExpanded: false
};

const slice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    loadUserProfile(state) {
      state.loading = true;
      state.error = null;
    },
    userProfileLoaded(state, action: PayloadAction<any>) {
      state.user = action.payload;
      state.loading = false;
      state.isAuthenticated = true;
    },
    profileError(state, action: PayloadAction<any>) {
      state.error = action.payload;
      state.loading = false;
      state.isAuthenticated = false;
    },
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setSavedViewsExpanded(state, action: PayloadAction<boolean>) {
      state.isSavedViewsExpanded = action.payload;
    },
    setMustWinsExpanded(state, action: PayloadAction<boolean>) {
      state.isMustWinsExpanded = action.payload;
    },
    openAiAssistant(state) {
      state.showAiAssistant = true;
    },
    closeAiAssistant(state) {
      state.showAiAssistant = false;
    },
    toggleAiAssistant(state) {
      state.showAiAssistant = !state.showAiAssistant;
    }
  }
});

export const { actions: layoutActions, reducer } = slice;

export const useLayoutSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: layoutSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useLayoutSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
